<template>
    <svg width="2" height="10" viewBox="0 0 2 10" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path d="M2 1C2 0.447715 1.55229 0 1 0C0.447715 0 0 0.447715 0 1V5C0 5.55228 0.447715 6 1 6C1.55229 6 2 5.55228 2 5V1Z" fill="white"/>
        <path d="M1 10C1.55229 10 2 9.55229 2 9C2 8.44771 1.55229 8 1 8C0.447715 8 0 8.44771 0 9C0 9.55229 0.447715 10 1 10Z" fill="white"/>
    </svg>
</template>

<script>
export default {
    name: 'IconUnion',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
